import React from 'react';
import classNames from 'classnames';
import { IconQuestionMark } from '@baidu/lsqm-icon';
import { Tooltip } from '@osui/ui';
import Field from './Field';
import './index.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function Card({
  size = 'large',
  className,
  title,
  children,
  extra,
  tooltip,
  topMessage
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(size === 'large' ? 'icloud-ui-card' : 'icloud-ui-card-small', className),
    children: [topMessage && /*#__PURE__*/_jsx("div", {
      className: classNames('icloud-ui-card-message'),
      children: topMessage
    }), (title || extra) && /*#__PURE__*/_jsxs("div", {
      className: "icloud-ui-card-title",
      children: [title, tooltip && /*#__PURE__*/_jsx(Tooltip, {
        title: tooltip,
        children: /*#__PURE__*/_jsx(IconQuestionMark, {
          className: "icloud-ui-card-Tooltip"
        })
      }), extra && /*#__PURE__*/_jsx("div", {
        className: "icloud-ui-card-extra",
        children: extra
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: classNames('icloud-ui-card-content'),
      children: children
    })]
  });
}

Card.displayName = "Card";
Card.Field = Field;
export default Card;
export * from './useFieldAlign';
//# sourceMappingURL=es/index.js.map